module.exports = __webpack_public_path__ + "static/tetrisapp-a96654a031f0e95290b51aee9d0c452b.png";